/* Runway — predictive search: /search/suggest via the Section Rendering API,
   plus client-side designer-name matching from the overlay's JSON blob. */
(function () {
  'use strict';

  let controller = null;
  let debounceTimer = null;

  function designers() {
    const el = document.getElementById('DesignersData');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  function designerStrip(q) {
    const hits = designers().filter((b) => b.toLowerCase().includes(q.toLowerCase()));
    if (!hits.length) return '';
    const links = hits
      .slice(0, 6)
      .map(
        (b) =>
          `<a href="${window.routes.search_url}?q=${encodeURIComponent(b)}&options%5Bprefix%5D=last">${b}</a>`
      )
      .join(' · ');
    return `<div class="search-designers">${window.theme.strings.designersLabel} ${links}</div>`;
  }

  async function run(q) {
    const out = document.getElementById('PredictiveResults');
    if (!out) return;
    if (q.length < 2) {
      out.innerHTML = '';
      return;
    }
    if (controller) controller.abort();
    controller = new AbortController();
    try {
      const url =
        `${window.routes.predictive_search_url}?q=${encodeURIComponent(q)}` +
        '&resources[type]=product&resources[limit]=8&section_id=predictive-search';
      const res = await fetch(url, { signal: controller.signal });
      if (!res.ok) return;
      const html = await res.text();
      const inner = new DOMParser()
        .parseFromString(html, 'text/html')
        .getElementById('PredictiveResultsInner');
      out.innerHTML = designerStrip(q) + (inner ? inner.innerHTML : '');
    } catch (err) {
      if (err.name !== 'AbortError') out.innerHTML = designerStrip(q);
    }
  }

  document.addEventListener('input', (e) => {
    if (e.target.id !== 'SearchInput') return;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => run(e.target.value.trim()), 300);
  });
})();
